import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import styles from './RowTabItems.module.scss'

const RowTabItems = ({
  items,
  onClick,
  activeAction
}) => {
  if(!items?.length) return null

  return (
    <span className={styles.wrapper}>
      {
        items.map((item, i) => {
          const IS_FIRST = i === 0
          const IS_LAST = i === items.length - 1

          const itemStyle = IS_FIRST
            ? styles.itemLeft
            : IS_LAST
              ? styles.itemRight
              : styles.itemCenter

          return (
            <section
              key={i}
              className={classNames(
                itemStyle,
                item?.icon && styles.itemIcon,
                item?.action === activeAction && styles.itemActive
              )}
              onClick={onClick(item?.action || 'NO_ACTION')}
            >
              {item?.icon && (
                <img
                  className={classNames(
                    item?.title && styles.mr4
                  )}
                  src={item.icon}
                  style={item?.iconInlineStyles}
                />
              )}

              {item?.title}
            </section>
          )
        })
      }
    </span>
  )
}

RowTabItems.propTypes = {
  items: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  activeAction: PropTypes.string
}

export default RowTabItems
